/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `View ${i.count} more`
};

const fr_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Voir ${i.count} de plus`
};

const de_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} mehr anzeigen`
};

const es_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Ver ${i.count} más`
};

const it_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Visualizza altri ${i.count}`
};

const ar_home_view_more_button18 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `عرض ${i.count} المزيد`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_view_more_button18 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_view_more_button18(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_view_more_button18", locale)
	if (locale === "en") return en_home_view_more_button18(inputs)
	if (locale === "fr") return fr_home_view_more_button18(inputs)
	if (locale === "de") return de_home_view_more_button18(inputs)
	if (locale === "es") return es_home_view_more_button18(inputs)
	if (locale === "it") return it_home_view_more_button18(inputs)
	return ar_home_view_more_button18(inputs)
};
export { home_view_more_button18 as "HOME_VIEW_MORE_BUTTON" }